import "./index.css";
import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import NotFound from "./routes/NotFound";
import Contact from "./routes/Contact";
import PrivacyPolicy from "./routes/PrivacyPolicy";
import TermsAndConditions from "./routes/TermsAndConditions";
import About from "./routes/About";
import Children from "./routes/services/Children.js";
import AnimationLayout from "./AnimationLayout.js";
import { useEffect } from "react";
import Lenis from '@studio-freight/lenis';
import Testimonials from "./routes/Testimonials.js";
import Orthodontics from "./routes/services/Orthodontics.js";
import Implantology from "./routes/services/Implantology.js";
import CompleteDiagnosis from "./routes/services/CompleteDiagnosis.js";
import SevenTen from "./routes/services/SevenTen.js";
import ElevenFifteen from "./routes/services/ElevenFifteen.js";
import Adults from "./routes/services/Adults.js";
import Aligners from "./routes/services/Aligners.js";
import BeforeAfter from "./routes/BeforeAfter.js";
import EDM from "./routes/services/EDM.js";

export default function App() {
    // useEffect(() => {
    //   const lenis = new Lenis({
    //     duration: 1, // speed
    //     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    //     direction: "vertical", // vertical, horizontal
    //     gestureDirection: "vertical", // vertical, horizontal, both
    //     smooth: true,
    //     mouseMultiplier: 0.5, // sensibility
    //     smoothTouch: false, // Mobile
    //     touchMultiplier: 2, // sensibility on mobile
    //     infinite: false // Infinite scrolling
    //   });
      
    //     function raf(time) {
    //         lenis.raf(time)
    //         requestAnimationFrame(raf)
    //     }
    //     requestAnimationFrame(raf)
    // }, [])

  return (
    <Routes>
      <Route element={<AnimationLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/beforeafter" element={<BeforeAfter />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/services/children" element={<Children />} />
        {/* <Route path="/services/7-10" element={<SevenTen />} /> */}
        <Route path="/services/teens" element={<ElevenFifteen />} />
        <Route path="/services/adults" element={<Adults />} />
        <Route path="/services/orthodontics" element={<Orthodontics />} />
        <Route path="/services/complete-diagnosis" element={<CompleteDiagnosis />} />
        <Route path="/services/aligners" element={<Aligners />} />
        <Route path="/services/implantology" element={<Implantology />} />
        <Route path="/services/edm" element={<EDM />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/*" element={<NotFound />} />
        </Route>
    </Routes>
  );
}
